import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListIsOnlineCell } from './channel-list-is-online.cell';
import { ChannelListIsOnlineHeader } from './channel-list-is-online.header';

export const ChannelListIsOnlineColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['isOnline']
> = {
  enableSorting: false,
  header: ChannelListIsOnlineHeader,
  cell: ChannelListIsOnlineCell,
  meta: { maxWidth: '60px', width: '40px' },
};
